import { PlanPurchaseFormData } from '../../PlanPurchaseFormData'
import { UseFormReturn } from 'react-hook-form'
import { UsePlanPurchaseFormPropsToSetFormValuesProps } from '@app/plans/src/PlanPurchaseForm/hooks/usePlanPurchaseFormPropsToSetFormValues/UsePlanPurchaseFormPropsToSetFormValuesProps'
import { useEffect } from 'react'

/**
 * FOR INTERNAL USE
 *
 * Tracks which props are given and uses those to overwrite the form values.
 * Any that are not given are expected to exist as form fields.
 */
export function usePlanPurchaseFormPropsToSetFormValues(
  props: UsePlanPurchaseFormPropsToSetFormValuesProps,
  form: UseFormReturn<PlanPurchaseFormData>
): void {
  const { planExtraDetails, existingOrgName, defaultValues } = props

  // Allow BuyPlanPage to continue to set the default plan interval on load
  // for `?promoCode` query param support.
  // TODO: remove this once we move coupon handling to the PlanPurchaseProvider
  useEffect(() => {
    if (!defaultValues?.planInterval) return
    form.setValue('planInterval', defaultValues.planInterval)
  }, [defaultValues?.planInterval, form])

  // If not tracked then it'll overwrite the defaultValues with undefined
  const planExtraDetailsGiven = 'planExtraDetails' in props
  const orgNameGiven = 'existingOrgName' in props

  useEffect(() => {
    if (!planExtraDetailsGiven) return
    form.setValue('planExtraDetails', planExtraDetails)
  }, [form, planExtraDetails, planExtraDetailsGiven])

  useEffect(() => {
    if (!orgNameGiven) return
    form.setValue('orgName', existingOrgName)
  }, [existingOrgName, form, orgNameGiven])
}
